import React, { Component } from 'react'
import {Helmet} from 'react-helmet'

import NavBar from '../../components/NavBar';
import PastCompetitionData from '../../components/PastCompetitionData';
import VideoGallery from '../../components/VideoGallery';

import { Container, Row, Col, Image } from 'react-bootstrap';

export default class PastCompetition2017 extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | The 2017 Competition</title>
                </Helmet>
                <NavBar hasHero={false} />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h1>The 2017 Competition</h1>
                        </Col>
                    </Row>
                    <PastCompetitionData teams="7" physicsTopic="Land Vehicle" chemistryTopic="Water Purification" winner="ABCIS" />
                    <br />
                    <Row>
                        <Col lg="4 auto">
                            <Image alt="Water Purification" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fwater_purification.jpeg?alt=media&token=cc330db6-22aa-414c-889e-ad8f87e3bb99" rounded fluid />
                        </Col>
                        <Col>
                            <p>
                                In 2017, there were seven teams from four schools in Ho Chi Minh City:  Saigon South 
                                International School, International School of Ho Chi Minh City, Korean International 
                                School, and European International School. Each team could include a maximum of seven 
                                members and one leader. Periodically, the team leaders had meetings with the Director of 
                                the competition to report on their progress as well as opinions for the hosting of the 
                                competition. 
                            </p>
                            <p>
                                This year, we added a chemistry topic in addition to a physics topic. Each 
                                team was asked to prepare a water purification system that can filter river water and a 
                                land vehicle that can travel the furthest using a handmade motor. Similar to the earlier 
                                competition, each team had six months of preparation including the summer between two school 
                                years.
                            </p>
                        </Col>
                    </Row>
                    <br />
                    <h2>Videos</h2>
                    <VideoGallery videos={
                        [
                            ["https://www.youtube.com/embed/ENB_2glRUQg", "ISHMIC Land Vehicle"],
                            ["https://www.youtube.com/embed/xFfhAe5JB-U", "ISHMIC Water Purification"],
                            ["https://www.youtube.com/embed/q2JHCndPLoY", "ABC 1 Land Vehicle"],
                            ["https://www.youtube.com/embed/yTkWem12uV8", "ABC 1 Water Purification"],
                            ["https://www.youtube.com/embed/WaUmLq5shWw", "ABC 2 Land Vehicle"],
                            ["https://www.youtube.com/embed/6EtjCIyvK6I", "ABC 2 Water Purification"],
                            ["https://www.youtube.com/embed/17bJi0CeBFQ", "EIS 1 Land Vehicle"],
                            ["https://www.youtube.com/embed/0x72qEFcC6M", "EIS 1 Water Purification"],
                            ["https://www.youtube.com/embed/q0X3d3t7ShU", "EIS 2 Land Vehicle"],
                            ["https://www.youtube.com/embed/asVdBGiYbYw", "EIS 2 Water Purification"],
                        ]
                    } />
                </Container>
            </div>
        )
    }
}
